<template>
    <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.5007 2.08203C6.77148 2.08203 2.08398 6.76953 2.08398 12.4987C2.08398 18.2279 6.77148 22.9154 12.5007 22.9154C18.2298 22.9154 22.9173 18.2279 22.9173 12.4987C22.9173 6.76953 18.2298 2.08203 12.5007 2.08203ZM9.19857 7.34245C10.2194 7.34245 11.0423 8.16536 11.0423 9.19662C11.0423 10.2174 10.2194 11.0404 9.19857 11.0404C8.16732 11.0404 7.3444 10.2174 7.3444 9.19662C7.3444 8.16536 8.16732 7.34245 9.19857 7.34245ZM15.8548 17.707C14.834 17.707 14.0111 16.8737 14.0111 15.8529C14.0111 14.832 14.834 14.0091 15.8548 14.0091C16.8757 14.0091 17.709 14.832 17.709 15.8529C17.709 16.8737 16.8757 17.707 15.8548 17.707ZM8.85482 17.7383L7.29232 16.1758L16.1777 7.29037L17.7402 8.85287L8.85482 17.7383Z"
            fill="currentColor"
        />
    </svg>
</template>

<script setup lang="ts"></script>
